import App from "./components/App";

import messages from "./config/constants/messages";
import titles from "./config/constants/titles";
import routes from "./config/constants/routes";
import menus from "./config/constants/menus";
import labels from "./config/constants/labels";

import {runPostTypesConfigSync} from "./postTypes";

export default function setContents(p = {}) {

    const {wapp} = p;

    function getTitle({wapp, res, title = titles.homeTitle}) {
        const config = wapp.getTargetObject().config;
        const {siteName = "Wapplr"} = config;
        const {statusCode, statusMessage, errorMessage} = res.wappResponse;
        if (statusCode === 404) {
            title = statusMessage || "Not found";
        }
        if (statusCode === 500) {
            title = errorMessage || statusMessage || "Internal Server Error";
        }
        return title + " | " + siteName;
    }

    wapp.contents.add({
        "home": {
            render: App,
            renderType: "react",
            title: function (p) {
                return getTitle({...p, title: titles.homeTitle})
            }
        }
    });

    wapp.router.replace([
        {path: "/" /*,...redirectToReadmeMd*/, contentName: "home"},
    ]);

    /*contents for post types, post, document, user...*/

    runPostTypesConfigSync({action:"setContents", p:{wapp, messages, routes, titles, menus, labels, getTitle}});

    /*contents for user account*/

    wapp.contents.add({
        account: {
            render: App,
            renderType: "react",
            title: function (p) {

                const wappResponse = p.res.wappResponse;
                const route = wappResponse.route;
                const {params} = route;

                let title;

                switch (params.page) {
                    case "changedata":
                        title = titles.changeDataTitle;
                        break;
                    case "changeemail":
                        title = titles.changeEmailTitle;
                        break;
                    case "changepassword":
                        title = titles.changePasswordTitle;
                        break;
                    case "forgotpassword":
                        title = titles.forgotPasswordTitle;
                        break;
                    case "deleteaccount":
                        title = titles.deleteAccountTitle;
                        break;
                    case "logout":
                        title = titles.logoutTitle;
                        break;
                    default:
                        title = titles.accountTitle
                }

                return getTitle({...p, title})
            }
        },
    });

    wapp.router.add([
        {path: routes.accountRoute, contentName: "account"},
        {path: routes.accountRoute+"/:page", contentName: "account"},
        {path: routes.accountRoute+"/*", contentName: "account"},
    ]);

}

export async function contentsMiddleware(req) {

    const wapp = req.wapp;

    if (!wapp.contents.contentManager.firstRequest) {
        wapp.contents.contentManager.firstRequest = async function ({req, res}) {

            const footerMenu = res.wappResponse.store.getState("res.responses.footerMenu");

            if (!footerMenu) {

                const response = await wapp.requests.send({
                    requestName: "documentFindManyByTags",
                    args: {
                        tags: ["footer-menu"]
                    },
                    req,
                    res
                });

                if (response && response["documentFindManyByTags"]) {

                    res.wappResponse.store.dispatch(wapp.states.stateManager.actions.res({
                        type: "INS_RES",
                        name: "responses",
                        value: {"footerMenu": response["documentFindManyByTags"], "documentFindManyByTags": null}
                    }));

                }

            }

        };
    }

}
